module.exports = "https://img.zhijierongxing.com/saas/img/de_icon2.c1652abc.png";